<template>
  <div style="width: 100%">
    <v-overlay
      absolute
      :value="$wait.is('loading campaigns getCampaingsByFilter')"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container
      v-if="!$wait.is('loading campaigns getCampaingsByFilter')"
      style="max-width: 1170px; height: 100%"
      id="mainContainer"
    >
      <TopLevelCampaigns />
      <webshop-click-and-collect-promo
        v-if="noSalonHasHomeShipment"
      ></webshop-click-and-collect-promo>
      <div class="mb-10">
        <webshop-product-carousel
          v-if="purchasedProducts.length > 0 && $user.onlineSluttKundeId"
          :boughtProducts="purchasedProducts"
          title="Sist kjøpte produkt"
        />
      </div>
      <MidLevelCampaigns class="mb-10" />
      <div v-if="bundles.length" class="pt-5 mb-10">
        <campaigns-bundle-carousel />
      </div>
      <LowLevelCampaigns class="mb-10" />
      <div class="mb-10">
        <RecommendationBox
          boxTitle="Populære produkter"
          class="titleCenter titleBold"
          :userId="this.$user.onlineSluttKundeId"
          presentation="carousel"
          :itemQty="12"
          :itemType="itemType.P"
          :chainId="parseInt(this.$route.params.chainId)"
          :location="location.PORTAL_PAGE"
          :channel="channel.FixitNo"
          :urlBase="urlBase"
          @buttonClick="addBtnAction"
          @cardClick="goToProductDetails"
          :cartItemsIds="cartItemIds"
        >
        </RecommendationBox>
      </div>
      <WebshopCategoriesGrid />
    </v-container>
  </div>
</template>
<script>
import {
  WebshopClickAndCollectPromo,
  WebshopCategoriesGrid,
} from "../components";
import imageTypes from "@/constants/image-types";
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import WebshopProductCarousel from "@/views/webshop/components/WebshopProductCarousel";
import CampaignsBundleCarousel from "@/views/webshop/components/CampaignsBundleCarousel";
import { mapWaitingActions } from "vue-wait";
import TopLevelCampaigns from "./campaignsPromotionComponents/TopLevelCampaigns";
import MidLevelCampaigns from "./campaignsPromotionComponents/MidLevelCampaigns";
import LowLevelCampaigns from "./campaignsPromotionComponents/LowLevelCampaigns";
import RecommendationBox from "@fixit/v-recommendation-box";
import {
  ItemType,
  Location,
  Channel,
} from "@fixit/v-recommendation-box/src/enums";
export default {
  components: {
    WebshopProductCarousel,
    WebshopClickAndCollectPromo,
    CampaignsBundleCarousel,
    TopLevelCampaigns,
    MidLevelCampaigns,
    LowLevelCampaigns,
    WebshopCategoriesGrid,
    RecommendationBox,
  },
  data() {
    return {
      imageTypes,
      itemType: ItemType,
      location: Location,
      channel: Channel,
    };
  },
  mixins: [webshopMixins],
  methods: {
    ...mapWaitingActions("campaigns", {
      getCampaingsByFilter: "loading campaigns getCampaingsByFilter",
    }),
    async addBtnAction(item) {
      var link = item.urlSafe.split("/");
      var product = await this.$store.dispatch("webshop/getProductsByIds", {
        avoidCache: true,
        chainId: parseInt(this.$route.params.chainId),
        includeCampaignProducts: true,
        isBase64: true,
        productIds: [link[1]],
      });
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product[0],
      });
      this.addProductToSalonCart(this.salons[0]);
    },
    goToProductDetails(item) {
      var link = item.urlSafe.split("/");
      this.$router
        .push({
          name: "webshopChainProductDetails",
          params: {
            productTitle: link[0],
            productId: link[1],
          },
        })
        .catch(() => {});
    },
  },
  computed: {
    noSalonHasHomeShipment() {
      return this.salons.filter((x) => x.homeShipmentEnabled).length === 0;
    },
  },
  watch: {
    $route: {
      async handler(val) {
        if (val.name == "webshopChain") {
          await this.getCampaingsByFilter(this.currentChainId);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.other_campaigns {
  .v-image__image--cover {
    max-height: 150px;
    width: 100%;
  }
}
</style>
